module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAoCAYAAADOvcv6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUVJREFUeNqUljFOAkEUhocXCitrWtHGxhtQUxA5ASfAABUmWNBYCFRAFE7gCVQ6m/UI9NBaW1GQ4D/JbPIyO8v8M8mXbDb5Muy3u2+pZFl2Y4yZgzX4MuSqgpbjFnyDAyMKeANbUAeP7I5WPIIHcAIjcMWKdv2Ad3ABFimiXUPwB+7dNdPiLxi746XbnRJNSihfpENJ4BwVSkrOR0OViTrUIhRKzlx/Hura/QJa1KGe/FASuc861DxF1KHaOhQjBkMJ+RYVQrFiIRQrFkKliMbtaFclRWyAjptJA0kYaq92J/AC9qzYBXdgB2Zs1Rp4dsf9fHwyot3hEnzogS0pQdhntRCEFfMg+zwII+ogvdD3RCJBPsu+YBIJ0mennA4y8YOcE3WQKTvJo0HKxGiQkEgF8UU6iC/SQfz8G9AEK/Yfh13/AgwAUVlWma1DALAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./public/img/icons/arrow-right2.png
// module id = 97
// module chunks = 0